import { createFileRoute } from "@tanstack/react-router";

import { ReportReviewAgentRoute } from "../../containers/ReportReviewAgentRoute";

export const Route = createFileRoute("/_layout-nosidebar/report-review-agent")({
    component: ReportReviewAgent,
});

function ReportReviewAgent() {
    return <ReportReviewAgentRoute />;
}
